export const Settings = {
  ProjectName: 'Dobro Dashboard'
};

Object.freeze(Settings);
